module.exports = __webpack_public_path__ + "img/9_Middle-T.bcaf814d.png";